import { useContext, useEffect, useRef, useState } from "react";
// import DateFilter from "../../Components/DateFilter"
import Prince from "../../Components/Prince"
import TopHeader from "../../Components/TopHeader"
import { Autocomplete, FormControl, InputLabel, MenuItem, TextField } from "@mui/material";
import Select from "@mui/material/Select";
import { getEmployeeDropdown, getb2bEmployeeDashboard, getB2BTodaysFollowUps } from "../../Services/dashboardService";
import TodoListCard from "./b2btodaymettinglist";
import Loader from "../../assets/img/loader.gif";
import DateFilter from "../Common/dashboardDatePicker";
import { useNavigate } from "react-router-dom";
import { DataContext } from "../../context/DataContext";



export const B2BDashBoard = () => {
    const [date, setDate] = useState(null);
    const [dateFilterModalOpen, setDateFilterModalOpen] = useState(false);
    const initialObject = { from: "", to: "", };
    const [filterByObj, setFilterByObj] = useState(initialObject);
    const [employeeList, setEmployeeList] = useState([]);
    const [selectedEmployee, setSelectedEmployee] = useState("");
    const [dashboardData, setDashboardData] = useState({});
    const [todoList, setTodoList] = useState([]);
    const [loadingTodo, setLoadingTodo] = useState(false);
    const [loader, setLoader] = useState(false);
    const [dateForApi, setDateForApi] = useState({ from: "", to: "", });
    const result = useContext(DataContext);
    const [employeeData, setEmployee] = useState({});
    const firstRender = useRef(true);
    const navigate = useNavigate();
    const handleSwitch = (e) => {
        if (e.target.checked) {
            navigate("/b2cdashboard");
        }
    };

    useEffect(() => {
        setEmployee(result.employeeData);
    }, [result.employeeData]);




    //  useEffect(() => {
    //     if (firstRender.current) {
    //         firstRender.current = false;
    //         return;
    //     }

    //     fetchDashboardData();
    // }, [selectedEmployee, dateForApi.from, dateForApi.to]);

    useEffect(() => {
        fetchDashboardData();
    }, [selectedEmployee, dateForApi.from, dateForApi.to]);


    //   for employe data fecth and others 
    useEffect(() => {
        // fetchDashboardData();
        fetchTodaysFollowUps();
        loadEmployees();
    }, []);

    const fetchTodaysFollowUps = async () => {
        try {
            setLoadingTodo(true);

            const response = await getB2BTodaysFollowUps();

            if (response?.data?.status === "success") {
                setTodoList(response.data.data || []);
            }
        } catch (error) {
            // console.error("Todo API Error:", error);
        } finally {
            setLoadingTodo(false);
        }
    };


    const fetchDashboardData = async () => {
        try {
            setLoader(true);

            const payload = {
                id: selectedEmployee || "",
                from: dateForApi.from,
                to: dateForApi.to,
            };

            const response = await getb2bEmployeeDashboard(payload);

            if (response?.data?.status === "success") {
                setDashboardData(response.data.data);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoader(false);
        }
    };




    const loadEmployees = async () => {
        try {
            const response = await getEmployeeDropdown();

            if (response?.data?.data) {
                setEmployeeList(response.data.data);
            }
        } catch (error) {
            console.error("Error fetching employees:", error);
        }
    };



    return (
        <>
           <div className="page">
                <TopHeader />
                <Prince />
                <div className="main-content pt-0" style={{ backgroundColor: "#fff" }}>
                    {loader && (
                        <div className="loading-overlay">
                            <img src={Loader} alt="Loading..." />
                        </div>
                    )}

                    <div className="container-fluid">
                        <div className="inner-body">

                            <div className="d-flex justify-content-between align-items-start flex-wrap gap-4 mb-4">

                                {/* Left Side */}
                                <div className="d-flex align-items-center flex-wrap gap-3">
                                    <div>
                                        <DateFilter setDateForApi={setDateForApi} />
                                    </div>

                                    <div className="mt-2" style={{ minWidth: "220px" }}>
                                        <Autocomplete
                                            size="small"
                                            options={employeeList || []}
                                            getOptionLabel={(option) => option?.name || ""}
                                            value={
                                                employeeList.find((emp) => emp.id === selectedEmployee) || null
                                            }
                                            onChange={(event, newValue) => {
                                                setSelectedEmployee(newValue ? newValue.id : "");
                                            }}
                                            isOptionEqualToValue={(option, value) => option.id === value.id}
                                            renderInput={(params) => (
                                                <TextField {...params} label="Select Employee" />
                                            )}
                                            filterOptions={(options, { inputValue }) =>
                                                options.filter((option) =>
                                                    option.name
                                                        ?.toLowerCase()
                                                        .includes(inputValue.toLowerCase())
                                                )
                                            }
                                        />
                                    </div>
                                </div>

                                {/* Right Side */}
                                <div
                                    className="d-flex flex-column align-items-end"
                                    style={{ minWidth: "600px" }}
                                >
                                    {(employeeData?.userType === "1" || employeeData?.accountType === "3") && (
                                        <div className="d-flex align-items-center gap-4 mt-2">
                                            {/* <span className="fw-semibold text-primary">Switch to B2C</span> */}

                                            {/* <div className="form-check form-switch mb-0">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="switchCheck"
                                                    defaultChecked
                                                    onChange={(e) => {
                                                        if (!e.target.checked) {
                                                            navigate("/b2cdashboard");
                                                        }
                                                    }}
                                                />
                                            </div> */}
                                        </div>
                                    )}

                                    <TodoListCard todoList={todoList} />
                                </div>
                            </div>

                            <div
                                className="position-relative"
                                style={{
                                    marginTop: employeeData?.userType === "1" ? "-150px" : "0px",
                                }}
                            >
                                {(employeeData?.userType === "1") && (
                                    <div>
                                        <h4 className="fw-semibold mb-4" style={{ color: "#2f3e73" }}>
                                            Total Employee
                                        </h4>

                                        <div className="row">
                                            <div className="col-xl-3 col-md-6 col-12 mb-4">
                                                <div
                                                    className="card shadow-sm border"
                                                    style={{
                                                        padding: "20px",
                                                        minHeight: "100px",
                                                        borderColor: "#d6d9de",
                                                        borderRadius: "12px"
                                                    }}
                                                >
                                                    <div className="d-flex justify-content-between align-items-center h-100">
                                                        <div>
                                                            <p className="mb-2 fw-semibold small text-dark">Employees</p>
                                                            <h2 className="mb-0 fw-bold" style={{ color: "#2f3e73" }}>
                                                                {dashboardData?.staffCount || 0}
                                                            </h2>
                                                        </div>

                                                        <div
                                                            className="d-flex align-items-center justify-content-center"
                                                            style={{
                                                                width: "52px",
                                                                height: "52px",
                                                                borderRadius: "50%",
                                                                background: "#eef2ff"
                                                            }}
                                                        >
                                                            <i className="fa fa-users" style={{ fontSize: "24px", color: "#2563eb" }}></i>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>


                                        </div>
                                    </div>
                                )}

                                <div className="">
                                    <h4 className="fw-semibold mb-4" style={{ color: "#2f3e73" }}>
                                        Today's Activity
                                    </h4>

                                    <div className="row">
                                        {/* Followup Calls */}
                                        <div className="col-xl-3 col-md-6 col-12 mb-4">
                                            <div
                                                className="card shadow-sm border"
                                                style={{
                                                    padding: "20px",
                                                    minHeight: "100px",
                                                    borderColor: "#d6d9de",
                                                    borderRadius: "12px"
                                                }}
                                            >
                                                <div className="d-flex justify-content-between align-items-center h-100">
                                                    <div>
                                                        <p className="mb-2 fw-semibold small text-dark">
                                                            Followup Calls
                                                        </p>

                                                        <h2
                                                            className="mb-0 fw-bold"
                                                            style={{
                                                                color: "#2f3e73",
                                                                wordBreak: "break-word"
                                                            }}
                                                        >
                                                            {dashboardData?.followUpCallCount || 0}
                                                        </h2>
                                                    </div>

                                                    <div
                                                        className="d-flex align-items-center justify-content-center"
                                                        style={{
                                                            width: "52px",
                                                            height: "52px",
                                                            borderRadius: "50%",
                                                            background: "#e8f5e9"
                                                        }}
                                                    >
                                                        <i
                                                            className="fa fa-refresh"
                                                            style={{ fontSize: "24px", color: "#16a34a" }}
                                                        ></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* New Calls */}
                                        <div className="col-xl-3 col-md-6 col-12 mb-4">
                                            <div
                                                className="card shadow-sm border"
                                                style={{
                                                    padding: "20px",
                                                    minHeight: "100px",
                                                    borderColor: "#d6d9de",
                                                    borderRadius: "12px"
                                                }}
                                            >
                                                <div className="d-flex justify-content-between align-items-center h-100">
                                                    <div>
                                                        <p className="mb-2 fw-semibold small text-dark">
                                                            New Calls
                                                        </p>

                                                        <h2
                                                            className="mb-0 fw-bold"
                                                            style={{
                                                                color: "#2f3e73",
                                                                wordBreak: "break-word"
                                                            }}
                                                        >
                                                            {dashboardData?.newCallCount || 0}
                                                        </h2>
                                                    </div>

                                                    <div
                                                        className="d-flex align-items-center justify-content-center"
                                                        style={{
                                                            width: "52px",
                                                            height: "52px",
                                                            borderRadius: "50%",
                                                            background: "#eef2ff"
                                                        }}
                                                    >
                                                        <i
                                                            className="fa fa-phone"
                                                            style={{ fontSize: "24px", color: "#2563eb" }}
                                                        ></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div className="">
                                    <h4 className="fw-semibold mb-4" style={{ color: "#2f3e73" }}>
                                        Lead Dashboard
                                    </h4>

                                    <div className="row">
                                        {/* All Leads */}
                                        <div className="col-xl-3 col-md-6 col-12 mb-4">
                                            <div
                                                className="card shadow-sm border"
                                                style={{
                                                    padding: "20px",
                                                    minHeight: "100px",
                                                    borderColor: "#d6d9de",
                                                    borderRadius: "12px"
                                                }}
                                            >
                                                <div className="d-flex justify-content-between align-items-center h-100">
                                                    <div>
                                                        <p className="mb-2 fw-semibold small text-dark">All Leads</p>
                                                        <h2 className="mb-0 fw-bold" style={{ color: "#2f3e73" }}>
                                                            {/* {dashboardData?.leadCount || 0} */}
                                                            {dashboardData?.openLeadCount || 0}
                                                        </h2>
                                                    </div>

                                                    <div
                                                        className="d-flex align-items-center justify-content-center"
                                                        style={{
                                                            width: "52px",
                                                            height: "52px",
                                                            borderRadius: "50%",
                                                            background: "#eef2ff"
                                                        }}
                                                    >
                                                        <i className="fa fa-users" style={{ fontSize: "24px", color: "#2563eb" }}></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Open Leads */}
                                        {/* <div className="col-xl-3 col-md-6 col-12 mb-4">
                                        <div
                                            className="card shadow-sm border"
                                            style={{
                                                padding: "20px",
                                                minHeight: "100px",
                                                borderColor: "#d6d9de",
                                                borderRadius: "12px"
                                            }}
                                        >
                                            <div className="d-flex justify-content-between align-items-center h-100">
                                                <div>
                                                    <p className="mb-2 fw-semibold small text-dark">Open Leads</p>
                                                    <h2 className="mb-0 fw-bold" style={{ color: "#2f3e73" }}>
                                                        {dashboardData?.openLeadCount || 0}
                                                    </h2>
                                                </div>

                                                <div
                                                    className="d-flex align-items-center justify-content-center"
                                                    style={{
                                                        width: "52px",
                                                        height: "52px",
                                                        borderRadius: "50%",
                                                        background: "#fff7e6"
                                                    }}
                                                >
                                                    <i className="fa fa-clock-o" style={{ fontSize: "24px", color: "#f59e0b" }}></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}

                                        {/* Won Leads */}
                                        <div className="col-xl-3 col-md-6 col-12 mb-4">
                                            <div
                                                className="card shadow-sm border"
                                                style={{
                                                    padding: "20px",
                                                    minHeight: "100px",
                                                    borderColor: "#d6d9de",
                                                    borderRadius: "12px"
                                                }}
                                            >
                                                <div className="d-flex justify-content-between align-items-center h-100">
                                                    <div>
                                                        <p className="mb-2 fw-semibold small text-dark">Won Leads</p>
                                                        <h2 className="mb-0 fw-bold" style={{ color: "#2f3e73" }}>
                                                            {dashboardData?.wonLeadCount || 0}
                                                        </h2>
                                                    </div>

                                                    <div
                                                        className="d-flex align-items-center justify-content-center"
                                                        style={{
                                                            width: "52px",
                                                            height: "52px",
                                                            borderRadius: "50%",
                                                            background: "#e8f5e9"
                                                        }}
                                                    >
                                                        <i className="fa fa-trophy" style={{ fontSize: "24px", color: "#16a34a" }}></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Lost Leads */}
                                        <div className="col-xl-3 col-md-6 col-12 mb-4">
                                            <div
                                                className="card shadow-sm border"
                                                style={{
                                                    padding: "20px",
                                                    minHeight: "100px",
                                                    borderColor: "#d6d9de",
                                                    borderRadius: "12px"
                                                }}
                                            >
                                                <div className="d-flex justify-content-between align-items-center h-100">
                                                    <div>
                                                        <p className="mb-2 fw-semibold small text-dark">Lost Leads</p>
                                                        <h2 className="mb-0 fw-bold" style={{ color: "#2f3e73" }}>
                                                            {dashboardData?.lostLeadCount || 0}
                                                        </h2>
                                                    </div>

                                                    <div
                                                        className="d-flex align-items-center justify-content-center"
                                                        style={{
                                                            width: "52px",
                                                            height: "52px",
                                                            borderRadius: "50%",
                                                            background: "#fff1f2"
                                                        }}
                                                    >
                                                        <i className="fa fa-ban" style={{ fontSize: "24px", color: "#dc2626" }}></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="">
                                    {/* <h4 className="fw-semibold mb-4" style={{ color: "#2f3e73" }}>
                                    Sales Dashboard
                                </h4> */}

                                    <div className="row">
                                        {/* KYC Complete */}


                                        {/* New */}
                                        <div className="col-xl-2 col-md-6 col-12 mb-4">
                                            <div
                                                className="card shadow-sm border"
                                                style={{
                                                    padding: "20px",
                                                    minHeight: "100px",
                                                    borderColor: "#d6d9de",
                                                    borderRadius: "12px"
                                                }}
                                            >
                                                <div className="d-flex justify-content-between align-items-center h-100">
                                                    <div>
                                                        <p className="mb-2 fw-semibold small text-dark">New</p>
                                                        <h2 className="mb-0 fw-bold" style={{ color: "#2f3e73" }}>{dashboardData?.newLeadCount || 0}</h2>
                                                    </div>

                                                    <div
                                                        className="d-flex align-items-center justify-content-center"
                                                        style={{
                                                            width: "52px",
                                                            height: "52px",
                                                            borderRadius: "50%",
                                                            background: "#fff7e6"
                                                        }}
                                                    >
                                                        <i className="fa fa-clock-o" style={{ fontSize: "24px", color: "#f59e0b" }}></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Call Attempted */}
                                        <div className="col-xl-2 col-md-6 col-12 mb-4">
                                            <div
                                                className="card shadow-sm border"
                                                style={{
                                                    padding: "20px",
                                                    minHeight: "100px",
                                                    borderColor: "#d6d9de",
                                                    borderRadius: "12px"
                                                }}
                                            >
                                                <div className="d-flex justify-content-between align-items-center h-100">
                                                    <div>
                                                        <p className="mb-2 fw-semibold small text-dark">Call Attempted</p>
                                                        <h2 className="mb-0 fw-bold" style={{ color: "#2f3e73" }}>{dashboardData?.callattemptedLeadCount || 0}</h2>
                                                    </div>

                                                    <div
                                                        className="d-flex align-items-center justify-content-center"
                                                        style={{
                                                            width: "52px",
                                                            height: "52px",
                                                            borderRadius: "50%",
                                                            background: "#eef2ff"
                                                        }}
                                                    >
                                                        <i className="fa fa-phone" style={{ fontSize: "24px", color: "#2563eb" }}></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Contact In-Future */}
                                        <div className="col-xl-2 col-md-6 col-12 mb-4">
                                            <div
                                                className="card shadow-sm border"
                                                style={{
                                                    padding: "20px",
                                                    minHeight: "100px",
                                                    borderColor: "#d6d9de",
                                                    borderRadius: "12px"
                                                }}
                                            >
                                                <div className="d-flex justify-content-between align-items-center h-100">
                                                    <div>
                                                        <p className="mb-2 fw-semibold small text-dark">Contact In-Future</p>
                                                        <h2 className="mb-0 fw-bold" style={{ color: "#2f3e73" }}>{dashboardData?.contactinfutureLeadCount || 0}</h2>
                                                    </div>

                                                    <div
                                                        className="d-flex align-items-center justify-content-center"
                                                        style={{
                                                            width: "52px",
                                                            height: "52px",
                                                            borderRadius: "50%",
                                                            background: "#f3e8ff"
                                                        }}
                                                    >
                                                        <i className="fa fa-calendar" style={{ fontSize: "24px", color: "#7c3aed" }}></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Follow Up */}
                                        <div className="col-xl-2 col-md-6 col-12 mb-4">
                                            <div
                                                className="card shadow-sm border"
                                                style={{
                                                    padding: "20px",
                                                    minHeight: "100px",
                                                    borderColor: "#d6d9de",
                                                    borderRadius: "12px"
                                                }}
                                            >
                                                <div className="d-flex justify-content-between align-items-center h-100">
                                                    <div>
                                                        <p className="mb-2 fw-semibold small text-dark">Follow Up</p>
                                                        <h2 className="mb-0 fw-bold" style={{ color: "#2f3e73" }}>{dashboardData?.followUPCount || 0}</h2>
                                                    </div>

                                                    <div
                                                        className="d-flex align-items-center justify-content-center"
                                                        style={{
                                                            width: "52px",
                                                            height: "52px",
                                                            borderRadius: "50%",
                                                            background: "#fff1f2"
                                                        }}
                                                    >
                                                        <i className="fa fa-refresh" style={{ fontSize: "24px", color: "#dc2626" }}></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-xl-2 col-md-6 col-12 mb-4">
                                            <div
                                                className="card shadow-sm border"
                                                style={{
                                                    padding: "20px",
                                                    minHeight: "100px",
                                                    borderColor: "#d6d9de",
                                                    borderRadius: "12px"
                                                }}
                                            >
                                                <div className="d-flex justify-content-between align-items-center h-100">
                                                    <div>
                                                        <p className="mb-2 fw-semibold small text-dark">Proposal</p>
                                                        <h2 className="mb-0 fw-bold" style={{ color: "#2f3e73" }}>{dashboardData?.proposalLeadCount || 0}</h2>
                                                    </div>

                                                    <div
                                                        className="d-flex align-items-center justify-content-center"
                                                        style={{
                                                            width: "52px",
                                                            height: "52px",
                                                            borderRadius: "50%",
                                                            background: "#e0f2fe"
                                                        }}
                                                    >
                                                        <i
                                                            className="fa fa-file-text-o"
                                                            style={{ fontSize: "24px", color: "#0ea5e9" }}
                                                        ></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Negotiation */}
                                        <div className="col-xl-2 col-md-6 col-12 mb-4">
                                            <div className="card shadow-sm border" style={{ padding: "20px", minHeight: "100px", borderColor: "#d6d9de", borderRadius: "12px" }}>
                                                <div className="d-flex justify-content-between align-items-center h-100">
                                                    <div>
                                                        <p className="mb-2 fw-semibold small text-dark">Negotiation</p>
                                                        <h2 className="mb-0 fw-bold" style={{ color: "#2f3e73" }}>{dashboardData?.negotiationLeadCount || 0}</h2>
                                                    </div>
                                                    <div className="d-flex align-items-center justify-content-center"
                                                        style={{ width: "52px", height: "52px", borderRadius: "50%", background: "#eff6ff" }}>
                                                        <i className="fa fa-handshake-o" style={{ fontSize: "24px", color: "#2563eb" }}></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* In-Integration */}
                                        <div className="col-xl-2 col-md-6 col-12 mb-4">
                                            <div className="card shadow-sm border" style={{ padding: "20px", minHeight: "100px", borderColor: "#d6d9de", borderRadius: "12px" }}>
                                                <div className="d-flex justify-content-between align-items-center h-100">
                                                    <div>
                                                        <p className="mb-2 fw-semibold small text-dark">In-Integration</p>
                                                        <h2 className="mb-0 fw-bold" style={{ color: "#2f3e73" }}>{dashboardData?.integrationinprogressLeadCount || 0}</h2>
                                                    </div>
                                                    <div className="d-flex align-items-center justify-content-center"
                                                        style={{ width: "52px", height: "52px", borderRadius: "50%", background: "#f3e8ff" }}>
                                                        <i className="fa fa-cogs" style={{ fontSize: "24px", color: "#7c3aed" }}></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Closed-Won-SYTS */}
                                        <div className="col-xl-2 col-md-6 col-12 mb-4">
                                            <div className="card shadow-sm border" style={{ padding: "20px", minHeight: "100px", borderColor: "#d6d9de", borderRadius: "12px" }}>
                                                <div className="d-flex justify-content-between align-items-center h-100">
                                                    <div>
                                                        <p className="mb-2 fw-semibold small text-dark">Closed-Won-SYTS</p>
                                                        <h2 className="mb-0 fw-bold" style={{ color: "#2f3e73" }}>{dashboardData?.closeCount || 0}</h2>
                                                    </div>
                                                    <div className="d-flex align-items-center justify-content-center"
                                                        style={{ width: "52px", height: "52px", borderRadius: "50%", background: "#e8f5e9" }}>
                                                        <i className="fa fa-trophy" style={{ fontSize: "24px", color: "#16a34a" }}></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Lost */}
                                        {/* <div className="col-xl-2 col-md-6 col-12 mb-4">
                                        <div className="card shadow-sm border" style={{ padding: "20px", minHeight: "100px", borderColor: "#d6d9de", borderRadius: "12px" }}>
                                            <div className="d-flex justify-content-between align-items-center h-100">
                                                <div>
                                                    <p className="mb-2 fw-semibold small text-dark">Lost</p>
                                                    <h2 className="mb-0 fw-bold" style={{ color: "#2f3e73" }}>{dashboardData?.loststageCount || 0}</h2>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-center"
                                                    style={{ width: "52px", height: "52px", borderRadius: "50%", background: "#fff1f2" }}>
                                                    <i className="fa fa-times-circle" style={{ fontSize: "24px", color: "#dc2626" }}></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}

                                        {/* Overdue */}
                                        <div className="col-xl-2 col-md-6 col-12 mb-4">
                                            <div className="card shadow-sm border" style={{ padding: "20px", minHeight: "100px", borderColor: "#d6d9de", borderRadius: "12px" }}>
                                                <div className="d-flex justify-content-between align-items-center h-100">
                                                    <div>
                                                        <p className="mb-2 fw-semibold small text-dark">Overdue</p>
                                                        <h2 className="mb-0 fw-bold" style={{ color: "#2f3e73" }}>{dashboardData?.overDueActivityCount || 0}</h2>
                                                    </div>
                                                    <div className="d-flex align-items-center justify-content-center"
                                                        style={{ width: "52px", height: "52px", borderRadius: "50%", background: "#fef3c7" }}>
                                                        <i className="fa fa-exclamation-circle" style={{ fontSize: "24px", color: "#f59e0b" }}></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Pending */}
                                        <div className="col-xl-2 col-md-6 col-12 mb-4">
                                            <div className="card shadow-sm border" style={{ padding: "20px", minHeight: "100px", borderColor: "#d6d9de", borderRadius: "12px" }}>
                                                <div className="d-flex justify-content-between align-items-center h-100">
                                                    <div>
                                                        <p className="mb-2 fw-semibold small text-dark">Pending</p>
                                                        <h2 className="mb-0 fw-bold" style={{ color: "#2f3e73" }}>{dashboardData?.pendingActivityCount || 0}</h2>
                                                    </div>
                                                    <div className="d-flex align-items-center justify-content-center"
                                                        style={{ width: "52px", height: "52px", borderRadius: "50%", background: "#fff7e6" }}>
                                                        <i className="fa fa-clock-o" style={{ fontSize: "24px", color: "#f59e0b" }}></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Completed */}
                                        {/* <div className="col-xl-2 col-md-6 col-12 mb-4">
                                        <div className="card shadow-sm border" style={{ padding: "20px", minHeight: "100px", borderColor: "#d6d9de", borderRadius: "12px" }}>
                                            <div className="d-flex justify-content-between align-items-center h-100">
                                                <div>
                                                    <p className="mb-2 fw-semibold small text-dark">Completed</p>
                                                    <h2 className="mb-0 fw-bold" style={{ color: "#2f3e73" }}>{dashboardData?.completedActivityCount || 0}</h2>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-center"
                                                    style={{ width: "52px", height: "52px", borderRadius: "50%", background: "#e8f5e9" }}>
                                                    <i className="fa fa-check-circle" style={{ fontSize: "24px", color: "#16a34a" }}></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}

                                        <div className="col-xl-2 col-md-6 col-12 mb-4">
                                            <div
                                                className="card shadow-sm border"
                                                style={{
                                                    padding: "20px",
                                                    minHeight: "100px",
                                                    borderColor: "#d6d9de",
                                                    borderRadius: "12px"
                                                }}
                                            >
                                                <div className="d-flex justify-content-between align-items-center h-100">
                                                    <div>
                                                        <p className="mb-2 fw-semibold small text-dark">KYC Complete</p>
                                                        <h2 className="mb-0 fw-bold" style={{ color: "#2f3e73" }}>{dashboardData?.kycLeadCount || 0}</h2>
                                                    </div>

                                                    <div
                                                        className="d-flex align-items-center justify-content-center"
                                                        style={{
                                                            width: "52px",
                                                            height: "52px",
                                                            borderRadius: "50%",
                                                            background: "#e8f5e9"
                                                        }}
                                                    >
                                                        <i className="fa fa-check-circle" style={{ fontSize: "24px", color: "#16a34a" }}></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                               


                            </div>

                        </div>
                    </div>
                </div>
                <div className="mt-4 w-100 text-center">
                    <div className="row mx-0 justify-content-center">
                        <div className="col-12 px-0">
                            <span className="d-block">
                                Copyright © 2026{" "}
                                <a href="/">DROPDASH</a>. Developed by{" "}
                                <a href="http://fship.in/">DROPDASH</a>. All rights reserved.
                            </span>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}